import { IntroVideoOptions } from '@/types/brandingThemes';
import { kebabCase } from '@/utils/string';
import { Grid } from '@mui/material';

type IntroVideoDemoProps = {
  introVideo: IntroVideoOptions;
};

export default function IntroVideoDemo({ introVideo }: IntroVideoDemoProps) {
  const videoUrl = `https://acct-mngt-service-prod-statics.s3.amazonaws.com/videos/intro-video-${kebabCase(
    introVideo,
  )}.mp4`;

  return (
    <Grid sx={{ textAlign: 'center' }} size={{ xs: 12, md: 6 }}>
      <video
        data-testid="branding-theme-video"
        style={{ maxWidth: '375px', width: '100%', margin: '0 auto' }}
        autoPlay
        controls
        src={videoUrl}
      />
    </Grid>
  );
}
